"use client";

import React from "react";

export type Locales = (typeof i18nRouting.locales)[number];
export const i18nRouting = {
  locales: ["en", "tr"],
  defaultLocale: "en",
};

export default function LocalizationProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return <React.Fragment>{children}</React.Fragment>;
}
